import * as React from 'react';
import Transition from '@components/Transition';
import { connect } from 'react-redux';
import { StoreState, Portfolio, Blog } from '@store/index';
import { TransitionProps } from 'react-transition-group/Transition';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface OwnProps extends TransitionProps, RouteComponentProps { }

interface Props {
    portfolios: Portfolio[];
    blogs: Blog[];
}
class TransitionContainer extends React.Component<Props & OwnProps> {
    render(): JSX.Element {
        return (<Transition {...this.props} />);
    }
}

const TransitionContainerConnected = connect<Props, {}, OwnProps>(
    (state: StoreState, ownProps: OwnProps) => {
        const { portfolios, blogs } = state;

        return { portfolios, blogs }
    }
)(TransitionContainer);

const TransitionContainerRouted = withRouter(TransitionContainerConnected);
export default TransitionContainerRouted;



// WEBPACK FOOTER //
// ./src/containers/Transition/index.tsx